import { useState } from "react";
import { useGetProvidersQuery } from "../../redux/service/appointments_service";
import { Loader } from "../../components/Loader";
import SelectedTickIcon from "../../components/Icons/SelectedTickIcon";

const ProviderList = ({ selectedProvider, setSelectedProvider }) => {
  const [searchTerm, setSearchTerm] = useState("");
  
  const { data, isLoading } = useGetProvidersQuery({
    role: 1,
    has_calendar: 1,
  });

  // Filter providers based on search term
  const filteredProviders = data?.filter((value) => {
    const name = value?.User?.name?.toLowerCase() || "";
    const specialty = value?.User?.specialty?.toLowerCase() || "";
    const search = searchTerm.toLowerCase();
    return name.includes(search) || specialty.includes(search);
  });

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Search Input */}
      <div className="sticky top-0 z-10 p-4 border-b border-gray-200 bg-gray-50 flex-shrink-0">
        <div className="relative">
          <input
            type="text"
            placeholder="Search providers by name or specialty..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <svg
            className="absolute left-3 top-2.5 h-5 w-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
      </div>

      {/* Provider List */}
      <div className="flex-1 overflow-y-auto">
        {filteredProviders?.map((value, index) => (
          <div
            key={value?.User?.id || index}
            className={`cursor-pointer transition-all duration-200 border-b border-gray-200 last:border-b-0 ${
              selectedProvider?.id === value?.User?.id
                ? "bg-blue-50 border-l-4 border-l-blue-500 shadow-sm"
                : "hover:bg-gray-50 border-l-4 border-l-transparent"
            }`}
            onClick={() => setSelectedProvider(value?.User)}
          >
            <div className="flex justify-between items-center p-4">
              <div className="flex items-center gap-3">
                {/* Avatar Circle */}
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold ${
                    selectedProvider?.id === value?.User?.id
                      ? "bg-blue-500"
                      : "bg-gray-400"
                  }`}
                >
                  {value?.User?.name?.charAt(0)?.toUpperCase() || "P"}
                </div>
                <div>
                  <p className="font-semibold text-gray-900">
                    {value?.User?.name}
                  </p>
                  {value?.User?.specialty && (
                    <p className="text-sm text-gray-600">
                      {value?.User?.specialty}
                    </p>
                  )}
                </div>
              </div>
              {selectedProvider?.id === value?.User?.id && (
                <SelectedTickIcon className="w-6 h-6 text-blue-500" />
              )}
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="py-8">
            <Loader />
          </div>
        )}
        {filteredProviders?.length === 0 && !isLoading && (
          <div className="py-8 text-center text-gray-500">
            <p className="text-lg">
              {searchTerm ? "No providers found matching your search" : "No providers available"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProviderList;
